import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { business } from "../../mock";

export default function CTA() {
  return (
    <section className="relative overflow-hidden bg-brand-stone py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal relative overflow-hidden rounded-3xl bg-brand-teal px-8 py-16 sm:px-16 sm:py-20">
          <div className="grain absolute inset-0" />
          <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-xl">
              <span className="kicker text-white/70">Free quotes · No obligation</span>
              <h2 className="mt-4 font-display text-4xl sm:text-5xl font-semibold tracking-tight text-white">
                Got a slab that needs cutting?
              </h2>
              <p className="mt-5 text-white/80 leading-relaxed">
                Send through the details, or a quick photo, and you&rsquo;ll get a
                straight answer and a fair price, usually the same day.
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
              <Link
                to="/quote"
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-4 text-sm font-semibold text-brand-ink transition-all duration-300 hover:bg-brand-ink hover:text-white"
              >
                Request a Quote
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <a
                href={business.phoneHref}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 px-7 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-white/10"
              >
                <Phone className="h-4 w-4" /> {business.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
